// This should be test name, followed by test ID. This allows us
// to make a small call to get the results
import { Environments } from '../../utils/constants';

// instead of having to pull in all the ongoing experiments.
export const ACTIVE_TESTS = {
    LYPS_SPACES_API: 43761,
    ULX_ADDRESS_VALIDATION: 43866,
    UFO_2FA_SECURITY_FT: 44561,
    PXO_GEOFEEDS: 49671
};

export const EGTNL_TESTS = {
    ULX_EGTNL_AA: 51086
};

export const EGTNL_TESTS_MPAAS = {
    ULX_PM_VACASA: 51104,
    ULX_VIDEO_TESTIMONIAL: 53621,
    TC_SUPPLY_VRBO: 50350,
    ULX_HOW_IT_WORKS_VR: 53776,
    ULX_VALUE_PROP_BANNER: 54315,
    ULX_LINK_COLLECTION: 55384,
    ULX_ADDRESSV2_VR: 56043,
    ULX_REBRANDING_VRBO_FF: 62557,
    ULX_PENDO_INTEGRATION: 56860
};
export const EGTNL_TESTS_KUMO = {
    ULX_ADDRESSV2: 52941,
    ULX_Classification_Video_Testimonial: 53687,
    ULX_HOW_IT_WORKS_CL: 53775,
    ULX_VALUE_PROP_BANNER_CL: 54357,
    ULX_REBRANDING_CL: 57760,
    ULX_UPL_INTEGRATION: 59220,
    ULX_CL_LINK_COLLECTION: 60454,
    ULX_CL_STICKY_ABC: 61621,
    ULX_SALESFORCE_IN_LYPS: 62724,
    ULX_ES_LX_LOCALE_CL: 62450,
    ULX_CL_SUBMARKETID_FETCHING: 63051
};

export const ACTIVE_TESTS_MPAAS = {
    PXO_CONTENT_MESSAGING_UPDATES: 48387,
    ULX_VR_AEM_ENABLED_ABACUS: 50460,
    ULX_AUTH_BYPASS_ABACUS: 50464,
    ULX_NEW_ADDRESS_VALIDATION_ABACUS: 50465
};


export const ACTIVE_TESTS_KUMO = {
    PXO_PROPERTY_NAME_INSTRUCTIONS: 48341,
    PXO_ADDRESS_IMPROVEMENTS_CL: 48472,
    ULX_DEDUPLICATION_EMAIL: 43629
};

export const UUID_TESTS = {
    ULX_UFO_INTEGRATION: 42830,
    UFO_UUID_AA: 46517
};

export const CL_TESTS_TO_EVALUATE = Object.assign({}, ACTIVE_TESTS, ACTIVE_TESTS_KUMO);
export const VRBO_TESTS_TO_EVALUATE = Object.assign({}, ACTIVE_TESTS, ACTIVE_TESTS_MPAAS);

export const EGTNL_URLS = {
    [Environments.PROD]: 'homeaway-experiment-access-production.us-east-1-vpc-d9087bbe.slb.prod.aws.away.black',
    [Environments.STAGE]: 'homeaway-experiment-access-stage.us-east-1-vpc-35196a52.slb.stage.aws.away.black',
    [Environments.DEV]: 'homeaway-experiment-access-stage.us-east-1-vpc-35196a52.slb.stage.aws.away.black',
    [Environments.TEST]: 'homeaway-experiment-access-stage.us-east-1-vpc-35196a52.slb.stage.aws.away.black'
};

export default {
    ACTIVE_TESTS,
    ACTIVE_TESTS_MPAAS,
    UUID_TESTS,
    EGTNL_URLS,
    ACTIVE_TESTS_KUMO
};
